export enum CalendarItemReminderType {
  // An alarm that keeps making noise till acknowledged
  Alarm = 'Alarm',
  // A popup notification
  Notification = 'Notification',
}

/** How we want to be reminded about a particular calendar item */
export type CalendarItemReminder = {
  type: CalendarItemReminderType;
  secondsOffset?: number;
};
